module.exports = __webpack_public_path__ + "static/media/icita2017.a230f56b.png";